export default __webpack_public_path__ + "static/media/circleAlert.1da92e86.svg";